import React from 'react';
import { get, post, put, del, patch } from '../../../../Utility/Http';
import { orgListingGet, orgCreatePost, orgDetailsGet, orgUpdatePatch, orgUpdatePatchApi, organizationDeleteApi, addUserPost, addUserPatch, orgCustRelationPostApi, userDetailsGet, userDeleteApi, usersInfoPost, usersInfoPatch, createOrgSettingPost, orgSettingGet, orgActivatePhoneNumberPost, getPhoneNumberActivateStatusGet, controlPanelPost, controlPanelPostget, webhookSettingPanelPost,webhookSettingPanelPatch, userMessageBalances } from '../Model/OrganizationModel';
import Config from '../../../../Utility/Config';

export const orgListing = (data) => {
    return get(`${Config.extendedUrl}organisation`, data).then((response) => {
        return orgListingGet(response)
    });
};
export const orgCreate = (data, id, type) => {
    if (type == "post") {
        return post(`${Config.extendedUrl}organisation`, data).then((response) => {
            return orgCreatePost(response)
        });
    } else {
        return patch(`${Config.extendedUrl}organisation/${id}`, data).then((response) => {
            return orgUpdatePatchApi(response)
        });
    }
};

export const orgDetails = (id, data) => {
    return get(`${Config.extendedUrl}organisation/${id}`, data).then((response) => {
        return orgDetailsGet(response)
    }); 
};
export const orgUpdate = (id, data) => {
    return patch(`${Config.extendedUrl}organisation/${id}`, data).then((response) => {
        return orgUpdatePatch(response)
    });
};

export const organizationDelete = (data) => {
    return del(`${Config.extendedUrl}organisation`, data).then((response) => {
        return organizationDeleteApi(response)
    });
};


export const addUser = (data, type, id) => {
    if (type == "post") {
        return post(`${Config.extendedUrl}admin/users`, data).then((response) => {
            return addUserPost(response)
        });
    } else {
        return patch(`${Config.extendedUrl}admin/users/${id}`, data).then((response) => {
            return addUserPatch(response)
        });
    }
};

export const orgCustRelationPost = (data) => {
    return post(`${Config.extendedUrl}org_cust_user`, data).then((response) => {
        return orgCustRelationPostApi(response)
    });
};

export const userDetails = (id, data) => {
    return get(`${Config.extendedUrl}admin/users_details/${id}`, data).then((response) => {
        return userDetailsGet(response)
    });
};
export const getUserMessageBalances = (id) => {
  return get(`${Config.extendedUrl}message-stats/${id}`, null).then((response) => {
    return userMessageBalances(response);
  });
};


export const userDelete = (data) => {
    return del(`${Config.extendedUrl}admin/users`, data).then((response) => {
        return userDeleteApi(response)
    });
};
export const usersInfo = (data, id, type) => {
    if (type == "post") {
        return post(`${Config.extendedUrl}users_info`, data).then((response) => {
            return usersInfoPost(response)
        });
    } else {
        return patch(`${Config.extendedUrl}users_info/${id}`, data).then((response) => {
            return usersInfoPatch(response)
        });
    }
};


export const createOrgSetting = (data) => {
    return post(`${Config.extendedUrl}organisation/create_org_settings`, data).then((response) => {
        return createOrgSettingPost(response)
    });
};
export const getOrgSetting = (data) => {
    return get(`${Config.extendedUrl}organisation_setting`, data).then((response) => {
        return orgSettingGet(response)
    });
};

export const orgActivatePhoneNumber = (data) => { //POST call //imtiaj
    return post(`${Config.extendedUrl}organisation/activate_phone_number`, data).then((response) => {
        return orgActivatePhoneNumberPost(response)
    });
};

export const getPhoneNumberActivateStatus = (data) => {
    return get(`${Config.extendedUrl}organisation/checking_phone_number_active_or_not`, data).then((response) => {
        return getPhoneNumberActivateStatusGet(response)
    });
};

export const controlPanel = async (data) => { //POST call //imtiaj
    const response = await post(`${Config.extendedUrl}ui-customization-defaults`, data);
    return controlPanelPost(response);
};
export const controlPanelGetApi = async (data) => { //POST call //imtiaj
    const response = await get(`${Config.extendedUrl}ui-customization-defaults`, data);
    return controlPanelPostget(response);
};

export const webhookSettingPanel = async (data, type) => {
    if (type == "post") {
        const response = await post(`${Config.extendedUrl}organisation/register_webhook`, data);
        return webhookSettingPanelPost(response);
    } 
    else {
        return patch(`${Config.extendedUrl}organisation/register_webhook`, data).then((response) => {
            return webhookSettingPanelPatch(response)
        });
    }
};